import { AnimatePresence, motion } from 'framer-motion';
import { SportsDistrictContext } from 'projectSpecific/sports/cnr/contexts/SportsDistrictContext';
import { _sportSponsorTypes } from 'projectSpecific/sports/useHelpers/useSportsSponsor';
import { useContext, useEffect, useMemo, useState } from 'react';

const _interval = 10000

const CardSponsor = ({
  sportSponsorType = _sportSponsorTypes.community,
  name = "",
  message = "",
  logo = "",
  url = "",
  className = "",
}) => {

  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { district_data } = sportsDistrict_state ?? {}
  const { sponsors } = district_data ?? {}

  const [currentIndex, setCurrentIndex] = useState(0)

  const sponsorList = useMemo(() => {
    const _sponsorList = _.filter(sponsors, sponsor =>
      sponsor?.active === true &&
      !_.isEmpty(
        _.intersection(sponsor?.sponsorTypes || [], [sportSponsorType, 'season'])
      )
    )
    return _sponsorList
  }, [sponsors])

  useEffect(() => {
    if (sponsorList.length <= 1) return
    const interval = setInterval(() => {
      setCurrentIndex(index => (index + 1) % sponsorList.length)
    }, _interval) // 10 seconds 
    return () => clearInterval(interval)
  }, [sponsorList.length])

  const currentSponsor = sponsorList?.[currentIndex]

  const card_sponsor = () => {
    const { name, _itemKey } = currentSponsor ?? {}
    return <div className={`sponsor-card ${className}`}>
      <div className="sponsor-content">
        {name && (
          <div className="sponsor-name">
            {name}
          </div>
        )}
      </div>
    </div>
  }

  const ap = () => <AnimatePresence mode="wait">
    <motion.div
      key={currentSponsor?._itemKey}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25 }}
    >
      {card_sponsor()}
    </motion.div>
  </AnimatePresence>

  const cards_sponsor = useMemo(() => {
    return ap()
  }, [currentSponsor])

  return cards_sponsor
};

export default CardSponsor